import "bootstrap";
// make Flickity a jQuery plugin
Flickity.setJQuery($);
jQueryBridget("flickity", Flickity, $);
/** is touch **/
function is_touch_device() {
  var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  var mq = function(query) {
    return window.matchMedia(query).matches;
  };
  if (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  ) {
    return true;
  }
  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
}

if (is_touch_device()) {
  $("body").addClass("isTouch");
} else {
  $("body").addClass("noTouch");
}

/** animate **/
function animateCSS(element, animationName, callback) {
  const node = document.querySelector(element);
  node.classList.add("animated", animationName);

  function handleAnimationEnd() {
    node.classList.remove("animated", animationName);
    node.removeEventListener("animationend", handleAnimationEnd);

    if (typeof callback === "function") callback();
  }

  node.addEventListener("animationend", handleAnimationEnd);
}

/** transitions after load **/
$(window).on("load", function() {
  $("body").removeClass("preload");
});

/** lazyload **/
const observer = lozad(".lozad", {
  rootMargin: "180px 0px",
  loaded: function(el) {
    el.classList.add("lozad-loaded");
  }
});
observer.observe();

/** anchor animation **/
$("a[href*=\\#]").on("click", function(event) {
  if (
    $(this.hash).length &&
    !$(this)
      .attr("href")
      .split("#")[0].length
  ) {
    event.preventDefault();
    $("html,body").animate({ scrollTop: $(this.hash).offset().top - 70 }, 1000);
  } else {
    return true;
  }
});

$(document).on("scroll", function(e) {
  $("[role='section']").each(function() {
    if (
      $(this).offset().top - 80 < window.pageYOffset &&
      $(this).offset().top + $(this).height() > window.pageYOffset + 30
    ) {
      var data = $(this).attr("id");
      history.replaceState({}, "", `#${data}`);
    }
  });

  var scrollHeight = $(document).height();
  var scrollPosition = $(window).height() + $(window).scrollTop();
  var scrollTop = $(window).scrollTop();
  var footerHeight = $("footer").height();
  var headerHeigh = $("header").height();

  if (scrollHeight < scrollPosition + footerHeight) {
    history.replaceState(
      "",
      document.title,
      window.location.pathname + window.location.search
    );
  }

  if (scrollTop < headerHeigh) {
    history.replaceState(
      "",
      document.title,
      window.location.pathname + window.location.search
    );
  }
});

/** sticky nav **/
function navScroll() {
  if ($(document).scrollTop() > $(window).height() / 20) {
    $("nav").addClass("scroll");
  } else {
    $("nav").removeClass("scroll");
  }

  if ($(".header-nav-placeholder").length) {
    $(".header-nav-placeholder").height($(".header-nav").outerHeight());
    $(".header-nav a").removeClass("active");
    $(".header-nav a").each(function() {
      var anchor = $(this).attr("href");
      if ($(anchor).length) {
        if ($(document).scrollTop() >= $(anchor).offset().top - 70) {
          $(this).addClass("active");
        }

        if (
          $(document).scrollTop() >
          $(anchor).offset().top + $(anchor).outerHeight() - 75
        ) {
          $(this).removeClass("active");
        }
      }
    });

    if ($(document).scrollTop() > $(".header-nav-placeholder").offset().top) {
      $(".header-nav").addClass("sticky");
      $("nav").addClass("hide");
    } else {
      $(".header-nav").removeClass("sticky");
      $("nav").removeClass("hide");
    }
  }
}

navScroll();

$(window).scroll(function() {
  navScroll();
});
$(window).resize(function() {
  navScroll();
});

/** compare hover **/
$(".noTouch .compare-table__item").hover(
  function() {
    $(".compare-table__item").removeClass("is-hover");
    $(this).addClass("is-hover");
  },
  function() {}
);

/** brands **/
$(".companies-carousel").flickity({
  cellAlign: "left",
  contain: true,
  freeScroll: true,
  pageDots: false,
  arrowShape: "M40.7,50l39.8,39.9L70.4,100L20.5,50L70.4,0l10.1,10.1L40.7,50z"
});

/** hamburger **/
$("body").on("click", ".hamburger", function() {
  if ($(this).hasClass("is-active")) {
    $(this).removeClass("is-active");
    $(".nav-main").removeClass("is-open");
  } else {
    $(this).addClass("is-active");
    $(".nav-main").addClass("is-open");
  }

  return false;
});

$(".people__item__info__more").on("click", function(e) {
  $(this)
    .parent()
    .html($(this).data("content"));
  e.preventDefault();
});

$(function() {
  $('[data-toggle="tooltip"]').tooltip();
});
